import React from 'react';
import { useIntl } from 'react-intl-next';
import { TextField } from '@atlassian/help-center-common-component/fields/text-field';
import { ThemedButton } from '@atlassian/help-center-common-component/themed-button';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { ButtonContainer } from '../login-single-sign-on/styled';
import messages from './messages';
import { Container, FooterContainer } from './styled';

export interface LoginSingleSignOnCustomerProps {
    email: string;
    redirectLink?: string;
    passwordLoginAvailable: boolean;
    onContinueWithPassword: () => void;
}

const LoginSingleSignOnCustomer = (props: LoginSingleSignOnCustomerProps) => {
    const { email, redirectLink, passwordLoginAvailable, onContinueWithPassword } = props;
    const { formatMessage } = useIntl();

    const getContinueWithPasswordLink = () => {
        return passwordLoginAvailable ? (
            <FooterContainer>
                <ThemedButton appearance="link" actionSubjectId="continueWithPassword" onClick={onContinueWithPassword}>
                    {formatMessage(messages.continueWithPasswordButton)}
                </ThemedButton>
            </FooterContainer>
        ) : undefined;
    };

    return (
        <Container>
            <FireScreenEventOnMount />
            <TextField
                id="user-email"
                shouldFitContainer
                label={formatMessage(messages.emailLabel)}
                disabled
                defaultValue={email}
            />
            <ButtonContainer>
                <ThemedButton
                    id="continue-with-customer-sso-button"
                    appearance="primary"
                    shouldFitContainer
                    actionSubjectId="continueWithCustomerSSO"
                    isDisabled={redirectLink === undefined}
                    href={redirectLink}
                    // Disabling existing violations, should be fixed when revisited.
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                >
                    {formatMessage(messages.continueWithSingleSignOnButton)}
                </ThemedButton>
            </ButtonContainer>
            {getContinueWithPasswordLink()}
        </Container>
    );
};

export default LoginSingleSignOnCustomer;
